import React, { Suspense, useMemo, useEffect } from "react";
import { baseUrl, fetchKmsData, translate } from "@mediaspace/shared/utils";
import { ErrorBoundary } from "@mediaspace/shared/ui";
import { KmsTypePublishCategory } from "@mediaspace/shared/types";
import { ChannelsTabForm, ChannelsTabFormProps } from "./ChannelsTabForm";
import { CategorySearchSkeleton } from "../category-search/CategorySearchSkeleton";
import { NoResults } from "../category-search/no-results/NoResults";
import { useButtonAnalytics } from "@mediaspace/hooks";
import { ButtonClickAnalyticsType } from "@mediaspace/shared/types/ButtonClickAnalyticsType";

interface ChannelsTabSearchResultsFormProps extends ChannelsTabFormProps {
	searchPublishChannels: () => { results: KmsTypePublishCategory[] };
}

/**
 * channel tab search reults checkboxes
 */
function ChannelsTabSearchResultsForm(props: ChannelsTabSearchResultsFormProps) {
	const { searchPublishChannels } = props;
	const { results } = searchPublishChannels();

	const sendButtonAnalytics = useButtonAnalytics();

	useEffect(
		() =>
			sendButtonAnalytics(
				`Publish - Set publishing settings modal box - search for channel`,
				ButtonClickAnalyticsType.SEARCH
			),
		[sendButtonAnalytics]
	);

    const hasResults = results && results.length > 0;

	return (
		<>
			{hasResults && <ChannelsTabForm {...props} userCategories={{}} channelResults={results} />}
			{!hasResults && <NoResults title={translate("No channels found")} />}
		</>
	);
}

interface ChannelsTabFormContainerProps extends ChannelsTabFormProps {
	keyword: string;
}

/**
 * Publish modal Channels tab suspense Container - handles channels search
 */
export function ChannelsTabFormContainer(props: ChannelsTabFormContainerProps) {
	const { keyword } = props;

	// fetch data from kms
	const searchPublishChannels = useMemo(
        () => keyword
            ? fetchKmsData<{ results: KmsTypePublishCategory[] }>(baseUrl + "/publishmedia/category/search/", {
                keyword: keyword,
                type: "channels",
            })
            : undefined,
		[keyword]
	);

	return (
		<>
			{!keyword && <ChannelsTabForm {...props} />}
			{keyword && (
				<ErrorBoundary fallback={<CategorySearchSkeleton />}>
					<Suspense fallback={<CategorySearchSkeleton />}>
						<ChannelsTabSearchResultsForm searchPublishChannels={searchPublishChannels!} {...props} />
					</Suspense>
				</ErrorBoundary>
			)}
		</>
	);
}
